//
//
//
//
//
//
//
//
//
//

import serviceHallHeader from '../components/layout/serviceHallHeader'

export default {
    middleware: 'appData',
    components: {
        serviceHallHeader
    },
    data() {
        return {
            opacity: 0.1
        }
    },
    computed: {
        backgroundStyle() {
            return {
                backgroundColor: `rgba(64, 116, 225, ${this.opacity})` // 红色背景，透明度可调
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed() {
        clearInterval(this.timer)
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll() {
            if (window.scrollY > 420) {
                this.opacity = 1
            } else if (window.scrollY < 60) {
                this.opacity = 0.1
            } else {
                this.opacity = window.scrollY / 420.0
            }
        }
    }
}
